import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { getCookie } from '../helpers/utils';

const API_URL = '/api/v1/duels_round';

@Injectable({
  providedIn: 'root'
})
export class DuelsRoundService {

  constructor(
    private http: HttpClient,
  ) { }

  private getCsrfToken(): string {
    return getCookie('csrftoken');
  }

  get(id: number) {
    return this.http.get(`${API_URL}/${id}/`);
  }

  update(id: number, round: any) {
    console.log('update', round);
    return this.http.put(`${API_URL}/${id}/`, round, {
      headers: {
        'X-CSRFToken': this.getCsrfToken()
      }
    })
  }

}
